import { InjectionToken } from '@angular/core';

export interface AssessmentEnvironment {
  workbenchApiUri: string;
}

export const AssessmentEnvironmentToken = new InjectionToken<AssessmentEnvironment>('AssessmentEnvironment');
